import { useAppDispatch } from "@/store/hooks";
import {
  updateAmountOffOrder,
  updateAmountOffProducts,
  updateBuyXGetY,
  updateFreeShipping,
} from "@/store/slices/discount.slice";
import {
  AmountOffOrder,
  AmountOffProducts,
  BuyXGetY,
  FreeShipping,
  PageType,
} from "@/types/coupon/discount";

type UpdatePayloadMap = {
  amountOffProducts: Partial<AmountOffProducts>;
  buyXGetY: Partial<BuyXGetY>;
  amountOffOrder: Partial<AmountOffOrder>;
  freeShipping: Partial<FreeShipping>;
};

const updateFunctionMap = {
  amountOffProducts: updateAmountOffProducts,
  buyXGetY: updateBuyXGetY,
  amountOffOrder: updateAmountOffOrder,
  freeShipping: updateFreeShipping,
} as const;

// Debug function to log current discount state
export const logDiscountState = (state: any, pageType: PageType) => {
  console.log(`[Discount State Debug] ${pageType}:`, {
    couponId: state.discount[pageType]?.couponId,
    title: state.discount[pageType]?.title,
    discount_code: state.discount[pageType]?.discount_code,
    start_date: state.discount[pageType]?.start_date,
    end_date: state.discount[pageType]?.end_date,
    currentTab: state.discount.currentTab,
    // Log applicable products/collections if they exist
    ...(state.discount[pageType]?.applicable_products && {
      applicable_products: state.discount[pageType].applicable_products,
    }),
    ...(state.discount[pageType]?.applicable_collections && {
      applicable_collections: state.discount[pageType].applicable_collections,
    }),
    ...(state.discount[pageType]?.applicable_x_products && {
      applicable_x_products: state.discount[pageType].applicable_x_products,
    }),
    ...(state.discount[pageType]?.applicable_y_products && {
      applicable_y_products: state.discount[pageType].applicable_y_products,
    }),
  });
};

export const useDiscountUpdate = () => {
  const dispatch = useAppDispatch();

  const handleUpdate = <T extends PageType>(
    currentPage: T,
    data: UpdatePayloadMap[T],
  ) => {
    const actionCreator = updateFunctionMap[currentPage];
    dispatch(actionCreator(data));
  };

  return handleUpdate;
};
